var map = {
	"./docker-plain.svg": 5904,
	"./figma-plain.svg": 454,
	"./gitlab-plain.svg": 7985,
	"./javascript-plain.svg": 2825,
	"./kubernetes-plain.svg": 8424,
	"./laravel-original.svg": 6378,
	"./php-plain.svg": 4362,
	"./storyblok.svg": 5294,
	"./typescript-plain.svg": 3497,
	"./vuejs-plain.svg": 3639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;